module.exports = __webpack_public_path__ + "static/btn.5a7b87f9.png";